<app-message-list-item-base
  #msg
  [message]="message"
  [inquiry]="inquiry"
  [currencySymbol]="currencySymbol"
  [viewPlainText]="viewPlainText"
  (editDraft)="editDraft.emit($event)"
  (aiGenerate)="aiGenerate.emit($event)"
  class=""
>
  <ng-container actions>
    <i class="fal fa-exclamation-triangle text-danger"
       *ngIf="isSpam"
       matTooltip="Spam"></i>
    <a
      matTooltip="Message details"
      matTooltipPosition="above"
      matTooltipClass="text-center"
      (click)="onDetails(message, inquiry)"
    >
      <i class="fal fa-info-circle"></i>
    </a>
    <a matTooltip="Print Message" matTooltipPosition="above" matTooltipClass="text-center" (click)="onPrint()">
      <i class="fal fa-print"></i>
    </a>
    <a
      *ngIf="hasMove && !(1 | isReadonlyRole)"
      matTooltip="Move to other inquiry"
      matTooltipPosition="above"
      matTooltipClass="text-center"
      (click)="onMove()"
    >
      <i class="fal fa-share"></i>
    </a>
    <a
      matTooltip="Delete"
      *ngIf="!(1 | isReadonlyRole)"
      matTooltipPosition="above"
      matTooltipClass="text-center"
      (click)="onRemove()"
    >
      <i class="fal fa-trash-alt"></i>
    </a>
    <a
      (click)="viewPlainText = !viewPlainText"
      [class.active]="viewPlainText"
      [matTooltip]="viewPlainText ? 'View styled text' : 'View plain text'"
      matTooltipPosition="above"
      matTooltipClass="text-center"
    >
      <i class="fal fa-file-alt"></i>
    </a>
  </ng-container>
</app-message-list-item-base>

<!-- For Print -->
<div #printableMessageContent class="d-none">
  <ul style="list-style: none; padding: 0">
    <li *ngIf="messageDetails?.from"><b>From:</b> {{ messageDetails?.from }}</li>
    <li *ngIf="messageDetails?.to"><b>To:</b> {{ messageDetails?.to }}</li>
    <li *ngIf="messageDetails?.cc"><b>CC:</b> {{ messageDetails?.cc }}</li>
    <li *ngIf="messageDetails?.bcc"><b>BCC:</b> {{ messageDetails?.bcc }}</li>
    <li *ngIf="messageDetails?.receivedOn"><b>Date:</b> {{ messageDetails?.receivedOn | epoch }}</li>
    <li *ngIf="messageDetails?.subject"><b>Subject:</b> {{ messageDetails?.subject }}</li>
    <li *ngIf="messageDetails?.id"><b>Id:</b> {{ messageDetails?.id }}</li>
  </ul>
  <div [innerHtml]="message.sanitizedMsgHtml"></div>
</div>
